import React from 'react'
import { Link } from 'react-router-dom'

import TinyInvoiceLogo from '../../../components/ui/logo'
import './styles.scss'

const year = new Date().getFullYear()

type FooterLinkProps = {
  to: string
  children: React.ReactNode
  staticLinks?: boolean
}

const FooterLink = ({ to, children, staticLinks }: FooterLinkProps) =>
  staticLinks ? (
    <a className='site-footer__link' href={to}>{children}</a>
  ) : (
    <Link className='site-footer__link' to={to}>{children}</Link>
  )

type FooterProps = {
  staticLinks?: boolean
}

const Footer = ({ staticLinks }: FooterProps) => {
  const HomeLogo = staticLinks ? (
    <a href='/' className='site-footer__logo'>
      <TinyInvoiceLogo width={168} />
    </a>
  ) : (
    <Link to='/' className='site-footer__logo'>
      <TinyInvoiceLogo width={168} />
    </Link>
  )

  return (
    <footer className='site-footer' role='contentinfo' aria-label='Site footer'>
      <div className='container col-xxl-8 site-footer__inner'>
        <div className='row g-4 g-lg-5 align-items-start'>
          <div className='col-12 col-lg-5'>
            <div className='site-footer__brand'>
              {HomeLogo}
              <p className='site-footer__tagline mb-3'>
                Simple invoicing for contractors, freelancers, small businesses, and any kind of gig workers.<br />Create and send professional PDF invoices
              </p>
              <a href='https://www.simpleanalytics.com?utm_source=tinyinvoice.app&utm_content=badge' referrerPolicy='origin' target='_blank' rel='noreferrer'>
                <picture>
                  <source
                    srcSet='https://simpleanalyticsbadges.com/tinyinvoice.app?mode=dark&radius=2&logo=5f6eff'
                    media='(prefers-color-scheme: dark)'
                  />
                  <img
                    src='https://simpleanalyticsbadges.com/tinyinvoice.app?mode=light&radius=2&logo=5f6eff'
                    loading='lazy'
                    referrerPolicy='no-referrer'
                    crossOrigin='anonymous'
                    alt='Simple analytics badge'
                  />
                </picture>
              </a>
            </div>
          </div>

          <div className='col-12 col-lg-7'>
            <div className='row g-4 site-footer__link-cols'>
              <div className='col-6'>
                <nav aria-label='Product'>
                  <h2 className='site-footer__heading'>Product</h2>
                  <ul className='site-footer__list'>
                    <li><FooterLink to='/signup' staticLinks={staticLinks}>Create invoice</FooterLink></li>
                    <li><FooterLink to='/blog' staticLinks={staticLinks}>Resources</FooterLink></li>
                    <li><FooterLink to='/pricing' staticLinks={staticLinks}>Pricing</FooterLink></li>
                  </ul>
                </nav>
              </div>
              <div className='col-6'>
                <nav aria-label='Company'>
                  <h2 className='site-footer__heading'>Company</h2>
                  <ul className='site-footer__list'>
                    <li><FooterLink to='/about' staticLinks={staticLinks}>About</FooterLink></li>
                    <li><FooterLink to='/faq' staticLinks={staticLinks}>FAQ</FooterLink></li>
                    <li><FooterLink to='/privacy' staticLinks={staticLinks}>Privacy Policy</FooterLink></li>
                    <li><FooterLink to='/terms' staticLinks={staticLinks}>Terms of Service</FooterLink></li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container col-xxl-8'>
        <hr className='site-footer__rule' />
        <div className='site-footer__bottom'>
          <p className='site-footer__copyright'>© {year} TinyInvoice.app | All rights reserved.</p>
          <p className='site-footer__credit'>
            Built by{' '}
            <a href='https://x.com/nicofetter' target='_blank' rel='noreferrer'>@nicofetter</a>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
